import ApiJobNameSuggestion from 'types/api/JobNameSuggestion';
import { Option } from 'types/options';

export default class JobNameSuggestion {
    name: string;
    count: number;

    constructor(data: ApiJobNameSuggestion) {
        this.name = data.name;
        this.count = data.count;
    }

    getOption = (): Option<JobNameSuggestion> => {
        return {
            value: this,
            label: this.name,
        };
    };
}
